<template>
  <!--抵扣优惠券-->
  <tk-container
    :status="status"
    infiniteScroll
    @refresh="refreshInit"
    ref="resetMyVouchers"
    @loadingMore="recommendedProducts"
  >
    <my-header slot="header" :icon="'fanhui'">{{$route.query.type !== 'freightVouchers' ? '优惠券' : '运费券'}}</my-header>
    <!--tab切换-->
    <div slot="header">
      <tk-flex
        around
        class="b-g-f p-t-10 tk-tabs"
      >
        <tk-flex
          center
          column
          @click.native="selectTab(index)"
          v-for="(s, index) in tabsList"
          :key="index"
        >
          <div :class="{'active-tab': s.isSelected === true}">{{s.text}}</div>
          <div class="tabs-line" :class="{'active-line': s.isSelected === true}"></div>
        </tk-flex>
      </tk-flex>
      <tk-flex middle class="msg-tips p-x-12 p-y-10">
        <tk-icon size="14" class="m-r-5" color="rgba(225, 182, 91, 1)">importantnotice</tk-icon>
        会员级别越高，每月可得越多
      </tk-flex>
    </div>
    <!--优惠券数据-->
    <card
      :width="100"
      :height="115"
      v-if="vouchersLoading"
    >
      <div class="item text-center" style="line-height: 80px;">
        <tk-spinner type="oval" color="rgba(153, 153, 153, 1)" size="25"></tk-spinner>
      </div>
    </card>
    <div
      class="m-x-12"
      style="position:relative;"
      v-else-if="vouchersData.length && !vouchersLoading"
    >
      <div style="height: 12px;"></div>
      <tk-flex
        :class="{'m-t-12': index > 0}"
        v-for="(s, index) in vouchersData"
        :key="index"
      >
        <tk-flex
          center
          column
          middle
          :class="{'closedCss': s.status === 'alreadyUsed'}"
          class="tk-grid-4 left-voucher"
          :style="`background-image: url('https://s3.moke.cloud/dianpei/bd38af39-22bc-44f9-ab40-9d760e260a6d.png') !important`"
        >
          <div class="font-18 font-bold">{{'￥' + ' ' + s.parValue}}</div>
          <div class="font-13">{{'满' + s.conditionsUse + '使用'}}</div>
        </tk-flex>
        <card :width="100" :height="115" class="tk-grid-8">
          <div class="van-ellipsis">{{s.name}}</div>
          <tk-flex middle right class="m-t-30">
            <tkui-button class="primary raised small btn-voucher" @click.native.stop="userVouchers" :disabled="s.status === 'alreadyUsed'">{{s.status === 'alreadyUsed' ? '已使用' : '去使用'}}</tkui-button>
          </tk-flex>
        </card>
        <!--选中优惠券的表示-->
        <div class="selectedId">
        </div>
      </tk-flex>
    </div>
    <card :width="100" :height="115" v-else>
      <empty-tips :width="100" :height="115" :empty-msg="'暂无数据'"></empty-tips>
    </card>
    <!--为你推荐数据-->
    <infinite-list :title="'为你推荐'" :infinite-list-pad="'p-x-12'" :products-data="getPriceProcessing(recommendedProductsData, judgeTimeRule)" :color="'#000000'"></infinite-list>
  </tk-container>
</template>

<script>
import { priceProcessing } from '@/assets/help/tool'
export default {
  data () {
    return {
      status: 'loading', // 页面状态
      vouchersLoading: false, // 获取优惠券数据状态
      notUsedSum: 0, // 可使用的优惠券数量
      alreadyUsedSum: 0, // 已使用的优惠券数量
      timeRule: {}, // 限时抢购时间规则
      tabsList: [ // tabsList数据
        {
          text: '可使用(0)',
          isSelected: true
        },
        {
          text: '已使用(0)',
          isSelected: false
        }
      ],
      recommendedProductsData: [], // 推荐的商品数据
      vouchersData: [] // 优惠券数据
    }
  },
  computed: {
    // 判断抢购时间是否有效
    judgeTimeRule () {
      if (!this.timeRule) return false
      let endSum = new Date(this.timeRule.endTime).getTime()
      let nowSum = new Date().getTime()
      return nowSum - endSum < 0
    }
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  mounted () {
    this.getInit()
  },
  methods: {
    /**
    * 页面初始化
    * @date: 2020/4/27
    */
    async getInit () {
      try {
        this.setStatusBar('dark')
        await this.getLimitedTimeRule() // 获取限时抢购的时间 （只获取1条）
        if (this.$route.query.type === 'coupons') {
          let notUsedSum = await this.statisticsNum('vouchers', { type: 'coupons', user: this.userInfo.objectId, status: 'notUsed' }) // 获取优惠券数量
          let alreadyUsedSum = await this.statisticsNum('vouchers', { type: 'coupons', user: this.userInfo.objectId, status: 'alreadyUsed' }) // 获取优惠券数量
          this.tabsList[0].text = `可使用(${notUsedSum})`
          this.tabsList[1].text = `已使用(${alreadyUsedSum})`
        } else {
          let notUsedSum = await this.statisticsNum('vouchers', { type: 'freightVouchers', user: this.userInfo.objectId, status: 'notUsed' }) // 获取优惠券数量
          let alreadyUsedSum = await this.statisticsNum('vouchers', { type: 'freightVouchers', user: this.userInfo.objectId, status: 'alreadyUsed' }) // 获取优惠券数量
          this.tabsList[0].text = `可使用(${notUsedSum})`
          this.tabsList[1].text = `已使用(${alreadyUsedSum})`
        }
        await this.getVouchers('notUsed')
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 页面错误时点击重新加载按钮 @resetInfiniteScroll
     * @date: 2020/4/27
     */
    async refreshInit () {
      this.recommendedProductsData = []
      await this.getInit()
      this.$refs.resetItsMine.resetInfiniteScroll()
    },
    /**
     * 限时抢购时间获取
     * @date: 2020/4/12
     */
    async getLimitedTimeRule () {
      let isoStartDate = new Date().toISOString()
      let startTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/startTime').catch(e => {
        return { data: null }
      })
      let endTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/endTime').catch(e => {
        return { data: null }
      })
      // 判断时间是否存在
      if (!startTime.data || !endTime.data) {
        this.timeRule = null
        return
      }
      let startSum = new Date(startTime.data).getTime()
      let nowSum = new Date(isoStartDate).getTime()
      if (nowSum <= startSum) {
        this.timeRule = null
        return
      }
      this.timeRule = {
        startTime: startTime.data,
        endTime: endTime.data
      }
    },
    async getVouchers (status) {
      let type = this.$route.query.type === 'freightVouchers' ? 'freightVouchers' : { $ne: 'freightVouchers' }
      let vouchers = await this.$tkParse.getList('/classes/vouchers', {
        params: {
          limit: 10000,
          where: {
            type: type,
            user: this.userInfo.objectId,
            status: status
          }
        }
      })
      if (vouchers.length) { this.vouchersData = vouchers } else { this.vouchersData = [] }
    },
    /**
    * tab选择
    * @date: 2020/4/27
    */
    async selectTab (index) {
      try {
        this.vouchersLoading = true
        this.tabsList.forEach(s => { s.isSelected = false })
        this.tabsList[index].isSelected = true
        let status = index === 0 ? 'notUsed' : 'alreadyUsed'
        await this.getVouchers(status)
        await this.$tkHelper.sleep(500)
        this.vouchersLoading = false
      } catch (e) {
        this.$tkGlobal.toast.add('选项卡未能正常切换')
      }
    },
    /**
    * 使用优惠券
    * @date: 2020/4/27
    */
    userVouchers () {
      this.$cleanHistory()
      this.$replace('/')
    },
    /**
     * 为你推荐数据获取
     * @date: 2020/4/27
     */
    async recommendedProducts (page, next) {
      let commodityData = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 10,
          skip: page * 10,
          order: '-sales',
          where: {
            shelvesStatus: 'shelves'
          }
        }
      })
      this.recommendedProductsData = [...this.recommendedProductsData, ...commodityData]
      if (commodityData.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    },
    /**
     * 工具转换
     * @date: 2020/4/27
     */
    getPriceProcessing (arr, rule) {
      return priceProcessing(arr, rule)
    }
  }
}
</script>

<style scoped lang="scss">
  /*tab样式*/
  .tk-tabs {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    .tabs-line {
      width: 22px;
      height: 3px;
      background-color: rgba(255, 255, 255, 0);
      border-radius: 2px;
      margin-top: 10px;
    }
    .active-line {
      background-color: rgba(225, 182, 91, 1);
    }
    .active-tab {
      color: #000000;
      font-weight: bold;
    }
  }
  /*消息提示样式*/
  .msg-tips {
    font-size: 12px;
    color: rgba(225, 182, 91, 1);
    min-height: 30px;
    background-color: rgba(237, 203, 118, 0.2);
  }
  /*优惠券样式*/
  .left-voucher {
    width: 100%;
    min-height: 115px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    color: #fff;
  }
  .btn-voucher {
    min-width: 65px;
    height: 27px;
    border-radius: 12px;
    margin: 0;
    padding-bottom: 3px;
    background:linear-gradient(to right, rgba(241,209,126,1),rgba(222,177,84,1));
  }
</style>
